export const startTooltip = (time) => {
  time = time ? time : 0

  //FG - ADDED LINE BELOW WHEN TABLES WERE MADE TO BE RESPONSIVE
  //     WHEN DATA IN v-client-tables CHANGES FORMAT (i.e. data from multiple
  //     columns are combined into a one column) SOME COLUMNS (i.e. ACTIONS)
  //     would display a tooltip when it should not.  This cures that.
  //     BUT every page that contains a table on which this might happen
  //     MUST have the following code in it.
  /*
    created() {
      this.$hydrowareCommonJS.handleTooltips("create");
    },

    destroyed() {
      this.$hydrowareCommonJS.handleTooltips("destroy");
    },
  */
  $('.tooltips').tooltipster('destroy')

  setTimeout(function () {

    /*$('table td').append('<span class="tooltips" title=""></span>')*/
    $('table td').removeClass('tooltips')
    $('table td').addClass('tooltips')


     // $('#calendar .tooltips').remove()
    $('#calendar td').removeClass('tooltips')
    $('#calendar td').removeClass('tooltipstered')
      $('#calender_table td').removeClass('tooltips')



    //$('table td').addClass()
    $('.tooltips').each(function () {

      if ($(this).find('.fc-head').length < 1) {

        var x = ''
        //$(this).text().replace(/\s/g,"")
        if ($(this).find('button').length < 1 && $(this).find('.el-switch').length < 1) {
          if (x) {


            //  $(this).find('.tooltips').attr('title', x)
            $(this).attr('data-tooltip-content', x)
          }

        }
      }
    })

    $('.tooltips').tooltipster({
      contentAsHTML: 'true',
      maxWidth: '300',
    })
    
    $('.tooltips').hover(function () {

      if ($(this).find('button').length < 1 && $(this).find('.el-switch').length < 1) {
        var ts = $(this).text().replace(/\s/g, '')
        if (ts) {

          $(this).tooltipster('content', $(this).text())
        }

      }
    })
  }, 600)

  $('.page-link').click(function () {
    $('table td').addClass('tooltips')
    setTimeout(function () {

      $('#calendar td').removeClass('tooltips')
      $('#calendar td').removeClass('tooltipstered')
      $('#calender_table td').removeClass('tooltips')


      //$('table td').addClass()
      $('.tooltips').each(function () {

        if ($(this).find('.fc-head').length < 1) {

          var x = $(this).text().replace(/\s/g, '')

          if ($(this).find('button').length < 1 && $(this).find('.el-switch').length < 1) {
            if (x) {


              //  $(this).find('.tooltips').attr('title', x)
              $(this).attr('data-tooltip-content', x)
            }

          }
        }
      })
      $('.tooltips').tooltipster({
        contentAsHTML: 'true',
        maxWidth: '300'
        /*     side: 'left',*/
      })
      $('.tooltips').hover(function () {
        if ($(this).find('button').length < 1 && $(this).find('.el-switch').length < 1) {
          var ts = $(this).text().replace(/\s/g, '')
          if (ts) {

            $(this).tooltipster('content', $(this).text())
          }

        }
      })

    }, 100)

  })

  setTimeout(function () {
    $('select').change(function () {

      setTimeout(function () {
        $('table td').addClass('tooltips')

        $('#calendar td').removeClass('tooltips')
        $('#calendar td').removeClass('tooltipstered')
        $('#calender_table td').removeClass('tooltips')


        //$('table td').addClass()
        $('.tooltips').each(function () {

          if ($(this).find('.fc-head').length < 1) {

            var x = $(this).text().replace(/\s/g, '')

            if ($(this).find('button').length < 1 && $(this).find('.el-switch').length < 1) {
              if (x) {


                //  $(this).find('.tooltips').attr('title', x)
                $(this).attr('data-tooltip-content', x)
              }

            }
          }
        })
        $('.tooltips').tooltipster({
          contentAsHTML: 'true',
          maxWidth: '300'
          /*     side: 'left',*/
        })
        $('.tooltips').hover(function () {
          if ($(this).find('button').length < 1 && $(this).find('.el-switch').length < 1) {
            var ts = $(this).text().replace(/\s/g, '')
            if (ts) {

              $(this).tooltipster('content', $(this).text())
            }

          }
        })

      }, 500)
    })

  }, 100)






  setTimeout(function () {
    $('.VueTables__search input').keyup(function () {

      setTimeout(function () {
        $('table td').addClass('tooltips')

        $('#calendar td').removeClass('tooltips')
        $('#calendar td').removeClass('tooltipstered')
        $('#calender_table td').removeClass('tooltips')


        //$('table td').addClass()
        $('.tooltips').each(function () {

          if ($(this).find('.fc-head').length < 1) {

            var x = $(this).text().replace(/\s/g, '')

            if ($(this).find('button').length < 1 && $(this).find('.el-switch').length < 1) {
              if (x) {


                //  $(this).find('.tooltips').attr('title', x)
                $(this).attr('data-tooltip-content', x)
              }

            }
          }
        })
        $('.tooltips').tooltipster({
          contentAsHTML: 'true',
          maxWidth: '300'
          /*     side: 'left',*/
        })
        $('.tooltips').hover(function () {
          if ($(this).find('button').length < 1 && $(this).find('.el-switch').length < 1) {
            var ts = $(this).text().replace(/\s/g, '')
            if (ts) {

              $(this).tooltipster('content', $(this).text())
            }

          }
        })

      }, 500)
    })

  }, 100)


  setTimeout(function () {
    $('.VueTables__limit select').change(function () {

      setTimeout(function () {
        $('table td').addClass('tooltips')

        $('#calendar td').removeClass('tooltips')
        $('#calendar td').removeClass('tooltipstered')
        $('#calender_table td').removeClass('tooltips')

        //$('table td').addClass()
        $('.tooltips').each(function () {

          if ($(this).find('.fc-head').length < 1) {

            var x = $(this).text().replace(/\s/g, '')

            if ($(this).find('button').length < 1 && $(this).find('.el-switch').length < 1) {
              if (x) {


                //  $(this).find('.tooltips').attr('title', x)
                $(this).attr('data-tooltip-content', x)
              }

            }
          }
        })
        $('.tooltips').tooltipster({
          contentAsHTML: 'true',
          maxWidth: '300'
          /*     side: 'left',*/
        })
        $('.tooltips').hover(function () {
          if ($(this).find('button').length < 1 && $(this).find('.el-switch').length < 1) {
            var ts = $(this).text().replace(/\s/g, '')
            if (ts) {

              $(this).tooltipster('content', $(this).text())
            }

          }
        })

      }, 500)
    })

  }, 100)





}




// WEBPACK FOOTER //
// ./src/components/loader/tooltip.js